import { render, staticRenderFns } from "./CustomerListItem.vue?vue&type=template&id=8bf2b7e4&scoped=true"
import script from "./CustomerListItem.vue?vue&type=script&lang=js"
export * from "./CustomerListItem.vue?vue&type=script&lang=js"
import style0 from "./CustomerListItem.vue?vue&type=style&index=0&id=8bf2b7e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf2b7e4",
  null
  
)

export default component.exports